  /**
   * @memberof rmOBA
   * @ngdoc directive
   * @name rmStagesNavigation
   * @param  {service} $location - Angular core: The $location service parses the URL in the browser address bar (based on the window.location) and makes the URL available to your application
   * @param {service} rmUserLocationData Service to retrieve location data from local storage
   * @param {service} rmUserLocationData Service to retrieve Postage Product data from local storage
   * @param {service} rmState Service storing state information about the UI
   * @description
   *   Breadcrumb navigation to navigate through stages of app.
   * @example
   *   Usage:
   *        <rm-intro-cookie-notice></rm-intro-cookie-notice>
   */
  
rmOBA.directive('rmStagesNavigation', [
    '$location', 
    'rmUserLocationData', 
    'rmUserPostalProductsData', 
    'rmState', function(
        $location,
        rmUserLocationData,
        rmUserPostalProductsData,
        rmState
    ) {
    return {
        restrict: 'E',
        templateUrl: 'directives/rmStagesNavigation/rmStagesNavigation.html',
        scope: true,
        link: function (scope) {

            var stage1Url = '/',
                stage2Url = '/02-order-details',
                stage3Url = '/03-email-and-print';

            scope.states = {};

            /**
            * @memberof rmStagesNavigation
            * @function enableLink
            * @desc Sets the enabled state of all navigation links
            */               
            scope.enableLink = function() {
                var locationData = rmUserLocationData.get(),
                    productData = rmUserPostalProductsData.get();

                if (!_.isEmpty(productData)) {
                    rmState.set('stage2Passed', true);
                }
                
                if (!_.isEmpty(locationData)) {
                    rmState.set('stage1Passed', true);
                } 
                // Retreive state info from service. 
                var rmStates = rmState.get();
                scope.states = rmStates;

                // Re route location to last completed stage
                if (_.isEmpty(productData) && $location.path() === stage3Url) {
                    $location.path(stage2Url);
                }
                if (_.isEmpty(locationData) && $location.path() === stage2Url) {
                    $location.path(stage1Url);
                }
            }

            scope.enableLink();

            /**
            * @memberof rmStagesNavigation
            * @function isSelected
            * @param {string} href - the current link path
            * @desc Sets selected state of the bound navigation link
            */        
            scope.isSelected = function(href) {
                // if location path matches this href 
                if (href === $location.path()) {
                    return true;
                }
            }

            /**
            * @memberof rmStagesNavigation
            * @function goToStage2
            * @desc Go to the next stage if previous is complete
            */        
            scope.goToStage2 = function() {
                if (scope.states.stage1Passed) {
                    $location.path(stage2Url);
                }
            };


            /**
            * @memberof rmStagesNavigation
            * @function goToStage3
            * @desc Go to the next stage if previous is complete
            */  
            scope.goToStage3 = function() {
                if (scope.states.stage2Passed) {
                    $location.path(stage3Url);
                }
            };
        }
    }
}]);